import { gql } from "@apollo/client"
import { PLAN_FRAGMENT } from "../../../fragments/PlanFragment"
import { DEPENDENTS_ON_ENGAGEMENT_FRAGMENT } from "../../../fragments/DependentsOnEngagementFragment"
import { DEPENDENTS_ON_ENROLLMENT_FRAGMENT } from "../../../fragments/DependentsOnEnrollmentFragment"
import { ENROLLMENT_COST_CONTRIBUTIONS_FRAGMENT } from "../../../fragments/EnrollmentCostContributionsFragment"
import { MONEY_FIELDS } from "~/shared/fragments/MoneyFields"

/* Extracted from ../../EmploymentPage.tsx to claim ownership by TME team */

export const SUGGESTED_BENEFITS_PROVISIONED_ENROLLMENT_FRAGMENT = gql`
  fragment SuggestedBenefitsProvisionedEnrollmentFragment on Engagement {
    state
    engagementType
    benefitsDescription
    benefitsProvisionedEnrollments {
      collection {
        plan {
          id
          name
          category
          provider {
            id
            automated
          }
        }
        enrollmentCostContributions {
          collection {
            contributor
            amountAsPercentage
          }
        }

        dependentsEmployerContributionMaxCount
        dependentsEmployerContribution
        employerContribution
      }
    }
    benefitsEnrolledPackages {
      collection {
        tier {
          id
          name
          includedPlans {
            ...PlanFragment
          }
        }
      }
    }
    benefitsProvisionedAddons {
      collection {
        ...PlanFragment
      }
    }
  }

  ${PLAN_FRAGMENT}
`

export const SUGGESTED_BENEFITS_ENROLLMENT_FRAGMENT = gql`
  ${MONEY_FIELDS}
  ${ENROLLMENT_COST_CONTRIBUTIONS_FRAGMENT}
  ${DEPENDENTS_ON_ENGAGEMENT_FRAGMENT}
  ${DEPENDENTS_ON_ENROLLMENT_FRAGMENT}
  fragment SuggestedBenefitsEnrollmentFragment on BenefitsEnrollment {
    id
    state
    coverageStartDate
    cancelledAt
    enrolledAt
    coverageEndDate
    availableEvents
    cancellationReason
    ...DependentsOnEnrollmentFragment
    ...EnrollmentCostContributionsFragment
    company {
      id
      name
    }
    totalPrice {
      ...MoneyFields
    }
    totalPriceInvoicedCompany {
      ...MoneyFields
    }

    tier {
      id
      name
      fee(engagementId: $engagementId, useSalaryCurrencyCode: $useSalaryCurrencyCode) {
        ...MoneyFields
      }
    }
    plan {
      id
      name
      category
      guideUrl
      descriptiveName
      provider {
        id
        name
        automated
      }
      fee(engagementId: $engagementId, useSalaryCurrencyCode: $useSalaryCurrencyCode) {
        ...MoneyFields
      }
    }
    engagement {
      id
      teamMemberName
      benefitsDescription
      ...DependentsOnEngagementFragment
      teamMember {
        id
        name
        avatarUrl
      }
    }
  }
`
